/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_DownloadingInputs */

const en_common_downloading = /** @type {(inputs: Common_DownloadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Downloading…`)
};

const es_common_downloading = /** @type {(inputs: Common_DownloadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descargando…`)
};

/**
* | output |
* | --- |
* | "Downloading…" |
*
* @param {Common_DownloadingInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const common_downloading = /** @type {((inputs?: Common_DownloadingInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_DownloadingInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_common_downloading(inputs)
	return en_common_downloading(inputs)
});